module.exports = __webpack_public_path__ + "static/media/alert-blue.9572591b.svg";